/* eslint-disable camelcase */
import React from 'react';
import Image from 'utils/image';

const CartItemImage = ({ cartIsStorefront, lineItem: { url, merchandise, image, product_title } }) => {
  return (
    <div className="size-[7.5rem] shrink-0 grow-0 basis-[7.5rem]">
      <a href={cartIsStorefront ? `/products/${merchandise.product.handle}` : url}>
        <Image
          src={image}
          alt={product_title}
          classes="w-full h-auto"
        />
      </a>
    </div>
  );
};

export default CartItemImage;
